import React from "react";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import { Paper, Typography } from "@mui/material";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

// Create Document Component
export default function Pdf({children}) {
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {children}
      </Page>
    </Document>
  );
}
